import { reactive } from "vue";

const theme = reactive({
  agentLogo: "",
  devLogo: "palms.png",
  apiUrl: "https://api.metaluxe.com.au/",
  bunnyApiUrl: "https://api.bunny.net/",
  accessKey:
    "ec558f34-7538-4b7e-b822-179253457e6b93932c0d-eae6-47b4-b444-1ac035b8ff7f",

  streamToken: "00fcd1ca-61e6-4bc9-99201e995469-b979-43c7",
  videoLibraryId: "365149",
  streamCdnUrl: "https://vz-6b0afba5-8f8.b-cdn.net",
  streamApiKey: "00fcd1ca-61e6-4bc9-99201e995469-b979-43c7",

  storageApiPassword: "1f2a224b-2c09-451b-8b8adf152975-e760-4f5d",
  cdnUrl: "https://the-palms-pwa.b-cdn.net",
  devFolder: "/the-palms-pwa",

  videosIcon: "/img/ui-theme/videos-icon.svg",
  rendersIcon: "/img/ui-theme/renders-icon.svg",
  rangeIcon: "/img/ui-theme/range-icon.svg",
  panoramasIcon: "/img/ui-theme/panoramas-icon.svg",
  floorplansIcon: "/img/ui-theme/floorplans-icon.svg",
  dashboardMp4: "theme/dashboard/4K_dashboard.mp4",

  // top level menu
  assetsMenuOrder: [
    "three-bed-villas",
    "four-bed-villas-Type-A",
    "four-bed-villas-type-B",
    "recreation-centre",
  ],
  type1MenuOrder: ["type-c-walkthrough", "type-c-360-tour", "renders"],
  walkthrough: ["earth-walkthrough", "sky-walkthrough"],
  tour: ["earth-tour", "sky-tour"],

  type1Asset: {
    videos: [],
    videosName: [],
    floorplans: ["Sky"],
    floorplansName: [0],
    floorplansUrl: ["https://storage.net-fs.com/hosting/7566552/162/"],
    panoramas: [0],
    panoramasName: [""],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/26/"],
    renders: [],
  },
});

export default { theme };
